import ShotList from './ShotList'

export default ShotList
